import { render, staticRenderFns } from "./ButtonPush.vue?vue&type=template&id=70c2fb1e"
import script from "./ButtonPush.vue?vue&type=script&lang=js"
export * from "./ButtonPush.vue?vue&type=script&lang=js"
import style0 from "./ButtonPush.vue?vue&type=style&index=0&id=70c2fb1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports